import type React from 'react';
import type {
  ErrorNotificationState,
  SuccessNotificationState,
  WarningNotificationState,
} from './notification-types';

type NotificationIconType =
  | SuccessNotificationState['type']
  | ErrorNotificationState['type']
  | WarningNotificationState['type'];

const notificationIconPaths: Record<NotificationIconType, string> = {
  success:
    'M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM14.707 7.29297C14.3165 6.90244 13.6835 6.90244 13.293 7.29297L9 11.5859L6.70703 9.29297C6.31651 8.90244 5.68349 8.90244 5.29297 9.29297C4.90244 9.68349 4.90244 10.3165 5.29297 10.707L8.29297 13.707C8.68349 14.0976 9.31651 14.0976 9.70703 13.707L14.707 8.70703C15.0976 8.31651 15.0976 7.68349 14.707 7.29297Z',
  error:
    'M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM13.707 6.29297C13.3165 5.90244 12.6835 5.90244 12.293 6.29297L10 8.58594L7.70703 6.29297C7.31651 5.90244 6.68349 5.90244 6.29297 6.29297C5.90244 6.68349 5.90244 7.31651 6.29297 7.70703L8.58594 10L6.29297 12.293C5.90244 12.6835 5.90244 13.3165 6.29297 13.707C6.68349 14.0976 7.31651 14.0976 7.70703 13.707L10 11.4141L12.293 13.707C12.6835 14.0976 13.3165 14.0976 13.707 13.707C14.0976 13.3165 14.0976 12.6835 13.707 12.293L11.4141 10L13.707 7.70703C14.0976 7.31651 14.0976 6.68349 13.707 6.29297Z',
  warning:
    'M10 1C14.9706 1 19 5.02944 19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1ZM10 13C9.44771 13 9 13.4477 9 14C9 14.5523 9.44771 15 10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13ZM10 5C9.44771 5 9 5.44772 9 6V10C9 10.5523 9.44771 11 10 11C10.5523 11 11 10.5523 11 10V6C11 5.44772 10.5523 5 10 5Z',
};

const notificationIconColors: Record<NotificationIconType, string> = {
  success: '#72C7C8',
  error: '#D5665F',
  warning: '#F3AB5A',
};

export const NotificationIcon: React.FC<{
  type: NotificationIconType;
}> = ({ type }) => (
  <svg
    className='notification-card__icon'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d={notificationIconPaths[type]}
      fill={notificationIconColors[type]}
    />
  </svg>
);

export const CloseNotificationIcon: React.FC = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M14.9991 5.70703L10.7062 9.99902L14.9991 14.291L14.2921 14.998L9.99915 10.7051L5.70715 14.998L5.00012 14.291L9.29211 9.99902L5.00012 5.70703L5.70715 5L9.99915 9.29199L14.2921 5L14.9991 5.70703Z'
      fill='#A3A3A3'
    />
  </svg>
);
